import { Store } from "vuex";
import { User } from "../types/schemaTypes.generated";
import { Modal } from "ant-design-vue";
import { DEFAULT_AVATAR_URL } from "@/src/shared/constants/user";

type UserLike = Pick<User, "id" | "avatarUrl"> & {
  detailUrl?: string | null;
};

export const getUserHrefUrl = function (user: UserLike) {
  if (user.detailUrl) {
    return user.detailUrl;
  }

  return `/users/${user.id}/profile`;
};

export const getUserAvatarSrc = function (user: UserLike, store: Store<any>) {
  if (!user.avatarUrl) {
    return DEFAULT_AVATAR_URL;
  }
  return user.avatarUrl;
};

export const removeProtocolFromUrl = function (url: string): string | null {
  if (!url) return null;
  const protocolRegex = /(^\w+:|^)\/\//;
  const adjustedUrl = url.replace(protocolRegex, "");
  return adjustedUrl;
};

export const showConfirm = function (params: {
  title: string;
  description: string;
  onOk: () => void;
  onCancel: () => void;
}): void {
  const { title, description, onOk, onCancel } = params;
  Modal.confirm({
    title,
    content: description,
    onOk: () => {
      return onOk();
    },
    onCancel: () => {
      return onCancel();
    },
    class: "ant__confirm excluded",
  });
};

export { getCurrentUserId } from "@/src/shared/utils/currentUser";

export const getCurrentUserAvatarUrl = (): string | null => {
  const currentUser = window.EASY.currentUser;
  return currentUser?.logged ? currentUser.avatar_url : null;
};

export const getCurrentUserName = (): string | null => {
  const currentUser = window.EASY.currentUser;
  return currentUser?.logged ? `${currentUser.firstName} ${currentUser.lastName}` : null;
};

/**
 * IANA identifier of the timezone the server formats this user's timestamps in
 * (see `_base_html_header.html.erb`). Null only when the header did not run.
 */
export const getCurrentUserTimeZone = (): string | null => window.EASY?.currentUser?.time_zone_identifier ?? null;

export const parseJsonString = (jsonString: string) => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Failed to parse JSON:", e);
    return null;
  }
};
